export { getCourseInstancePath } from './flag.on/helpers'
